import dataStore from '../../data/data';
import Loader from './load/loader';

const Generate = async () => {
  const data=dataStore.getState();
  const setData=dataStore.setState;
  let date = data.mirror.currentDate;

  if (!date) {
    date = new Date().toLocaleDateString('en-US', {
      timeZone: 'UTC',
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    }).replace(/\//g, '-');

    setData((_data) => ({
      ..._data,
      mirror: {
        ..._data.mirror,
        currentDate: date,
      },
    }));
  }
  
  await Loader();

};

export default Generate;
